import styled from 'styled-components';

export const container = styled.div`
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  gap: var(--s2);
  user-select: none;

  &.reverse {
    flex-direction: row-reverse;
    width: 100%;
  }

  &.bottomLine {
    border-bottom: 1px solid var(--line);
  }

  && .ant-switch {
    min-width: 34px;
    width: 34px;
    height: 19px;
    background: var(--line-strong);
  }

  && .ant-switch:hover:not(.ant-switch-disabled) {
    background: var(--text-faint);
  }

  /* A switch nobody may flip reads quiet, and its label goes with it. */
  &.disabled {
    cursor: not-allowed;
  }

  &.disabled p {
    color: var(--text-faint);
  }

  && .ant-switch.ant-switch-disabled {
    opacity: 0.45;
  }

  && .ant-switch.ant-switch-checked,
  && .ant-switch.ant-switch-checked:hover:not(.ant-switch-disabled) {
    background: var(--ok);
  }

  && .ant-switch .ant-switch-handle {
    width: 15px;
    height: 15px;
    top: 2px;
    inset-inline-start: 2px;
  }

  && .ant-switch.ant-switch-checked .ant-switch-handle {
    inset-inline-start: calc(100% - 17px);
  }
`;

export const box = styled.div`
  line-height: 0;
`;

export const P = styled.p`
  font-size: var(--fs-body);
  font-weight: var(--fw-medium);
  color: var(--text-muted);

  &.active {
    color: var(--ok);
  }
`;

export const icon = styled.div`
  width: 15px;
  height: 15px;
  line-height: 0;
`;

export const Input = styled.input``;
